import React from 'react'
import s from './DocumentsBlock.module.scss'
import { ReactComponent as Icon } from 'assets/icons/folder.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_back.svg'
import useDocumentsBlock from './hooks/useDocumentsBlock'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'

const SKELETON_TAGS = [
	{ id: 'sk-transcripts', label: 'Transcripts' },
	{ id: 'sk-resume', label: 'Resume' },
	{ id: 'sk-scores', label: 'Scores' },
	{ id: 'sk-sop', label: 'SOP' },
]

const DocumentsBlock = ({ studentId, onViewAll }) => {
	const { categories, formatCount, isLoading } = useDocumentsBlock({
		studentId,
	})

	const showSkeletons = isLoading && categories.length === 0
	const tags = showSkeletons ? SKELETON_TAGS : categories

	return (
		<section className={s.card}>
			<div className={s.head}>
				<span className={s.head__icon}>
					<Icon />
				</span>
				<h3 className={s.head__title}>Documents</h3>
				{onViewAll && (
					<button
						type="button"
						className={`${s.view} ${s.viewTop}`}
						onClick={onViewAll}
						disabled={isLoading}
					>
						View All
					</button>
				)}
			</div>

			<div
				className={s.tags}
				aria-busy={isLoading}
				aria-label={isLoading ? 'Loading documents' : undefined}
			>
				{tags.length > 0 ? (
					tags.map(category => (
						<div
							key={category.id}
							className={`${s.tag}${showSkeletons ? ` ${s.tagSkeleton}` : ''}`}
						>
							<span className={s.tag__label}>{category.label}</span>
							{isLoading || showSkeletons ? (
								<span className={`${s.loader} ${s.loaderValue}`}>
									<LoaderImg />
								</span>
							) : (
								<span className={s.tag__value}>
									{formatCount(category.count)}
								</span>
							)}
						</div>
					))
				) : (
					<p className={s.empty}>No documents yet</p>
				)}
			</div>

			{onViewAll && (
				<button
					type="button"
					className={`${s.view} ${s.viewBottom} ${isLoading ? s.disable : ''}`}
					onClick={onViewAll}
					disabled={isLoading}
				>
					View All
					<span className={s.view__arrow}>
						<ArrowIcon />
					</span>
				</button>
			)}
		</section>
	)
}

export default DocumentsBlock
